// extracted by mini-css-extract-plugin
export default {"root":"ReportListingButton_root__LhGmB","reportButton":"ReportListingButton_reportButton__-3LXM p"};